import { _$id, _addEventListener, } from '../util/dom';
import { _addKeyHandlers, } from './key-handlers';
const _store = {}, _storeHandlers = {}, _loadHandlers = {}, _addStoreHandlers = (key, loadHandler, storeHandler) => {
    _loadHandlers[key] = loadHandler;
    _storeHandlers[key] = storeHandler;
}, _loadFromUrl = () => {
    _populateStoreFromUrl();
    for (const key in _loadHandlers) {
        const storeValue = _store[key];
        if (storeValue === undefined) {
            continue;
        }
        const loadHandler = _loadHandlers[key];
        loadHandler(storeValue);
    }
}, _populateStoreFromUrl = () => {
    const hash = window.location.hash;
    if (hash.length <= 1) {
        return;
    }
    const serializedState = hash.slice(1), states = serializedState.split(_stateSeparatorSymbol);
    for (const state of states) {
        const [key, stateValue] = state.split(_stateLinkSymbol);
        _store[key] = stateValue;
    }
}, _storeToUrl = () => {
    for (const key in _storeHandlers) {
        const storeHandler = _storeHandlers[key];
        _store[key] = storeHandler();
    }
    _saveStoreToUrl();
}, _saveStoreToUrl = () => {
    const serializedState = _serializeStore(), loc = window.location, newUrl = loc.pathname + loc.search + '#' + serializedState;
    window.history.pushState('', '', newUrl);
}, _serializeStore = () => {
    const states = [];
    for (const key in _store) {
        const stateValue = _store[key], stateMapping = key + _stateLinkSymbol + stateValue;
        states.push(stateMapping);
    }
    return states.join(_stateSeparatorSymbol);
}, _stateLinkSymbol = ':', _stateSeparatorSymbol = '/', $permalinkButton = _$id('permalink');
_addEventListener($permalinkButton, 'click', _storeToUrl);
_addKeyHandlers('p', _storeToUrl);
_addEventListener(window, 'load', _loadFromUrl);
_addEventListener(window, 'hashchange', _loadFromUrl);
export { _addStoreHandlers, };
